( function () {
  angular.module('edxResources')
    .component('edxDemoLessons', {
      bindings: {
        label: '<',
        imageUrl: '<',
        lessonName: '<',
        lessonFriendlyName: '<',
      },
      templateUrl: '/resources/components/edx-resources/edx-demo-lessons.component.html',
      controllerAs: 'vm',
      controller: [
        '$scope',
        'dblLessonService',
        '$window',
        EdexDemoLessons
      ]
    });

  function EdexDemoLessons( $scope, dblLessonService, $window
  ) {
    $scope.handlePlayDemoClick = handlePlayDemoLesson;
    function handlePlayDemoLesson($event, lessonName){
      $event.stopPropagation();
      openDemoLink(lessonName);
    }

    function openDemoLink(lessonSlotName) {
      $window.open(dblLessonService.getDemoLink(lessonSlotName), '_blank');
    }

  }
})();
